// src/components/OperatorRedirect.jsx

import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useDataLayer } from '@quantiix/data-layer';
import { createLogger } from '../utils/logger';

const logger = createLogger('Shell::OperatorRedirect');

export const OperatorRedirect = ({ children }) => {
    const { isAuthenticated, permissions, loading } = useAuth();
    const { setScope } = useDataLayer();
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        if (loading) return;
        if (!isAuthenticated) return;

        // Only redirect from home page (post-login landing)
        if (location.pathname !== '/') return;

        const isOperator = permissions.roles?.includes('operator');
        const assignedMachine = permissions.machines?.[0];
        const assignedCompany = permissions.company?.[0];
        const assignedFactory = permissions.factories?.[0];

        if (isOperator && assignedMachine && assignedCompany) {
            // Extract IDs from objects (permissions may contain objects or strings)
            const companyId = typeof assignedCompany === 'object' ? assignedCompany.id : assignedCompany;
            const factoryId = typeof assignedFactory === 'object' ? assignedFactory.id : assignedFactory;

            logger.info('Operator detected, redirecting to operator view', {
                machineId: assignedMachine,
                companyId,
                factoryId
            });

            // Set context before navigating
            setScope({
                companyId,
                factoryId,
                machineId: assignedMachine
            });

            navigate(`/app/operator/${assignedMachine}`, { replace: true });
        }
    }, [isAuthenticated, permissions, loading, location.pathname, navigate, setScope]);

    return children;
};